// extracted by mini-css-extract-plugin
var _1 = "t2NU";
var _2 = "t2NT";
var _3 = "t2NS";
var _4 = "t2NQ";
var _5 = "t2NR";
var _6 = "t2NP";
export { _1 as "button", _2 as "footer", _3 as "progress", _4 as "success", _5 as "text", _6 as "title" }
